(function() {
  const drawer = document.querySelector('cart-drawer.kc-cart');
  if (!drawer) return;

  const itemsEl = drawer.querySelector('#KC-CartItems');
  const subtotalEl = drawer.querySelector('[data-kc-subtotal]');
  const progressEl = drawer.querySelector('#KC-CartProgress');
  const progressBar = drawer.querySelector('[data-kc-progress-bar]');
  const saveMoreEl = drawer.querySelector('#KC-SaveMore');
  const saveMoreGrid = drawer.querySelector('[data-kc-save-more-grid]');
  const savedRow = drawer.querySelector('[data-kc-saved]');
  const savedAmt = drawer.querySelector('[data-kc-saved-amount]');
  const catalogScript = drawer.querySelector('[data-kc-upsell-catalog]');
  let CATALOG = { hats: [], protections: [] };
  if (catalogScript) {
    try { CATALOG = JSON.parse(catalogScript.textContent); } catch (e) { CATALOG = { hats: [], protections: [] }; }
  }

  const i18nScript = drawer.querySelector('[data-kc-i18n]');
  let I18N = {};
  if (i18nScript) { try { I18N = JSON.parse(i18nScript.textContent); } catch (e) { I18N = {}; } }
  const PATTERNS = I18N.patterns || {};

  // 2026-10-07 (Émile): the offer. 1st helmet −first % (Shopify sale price),
  // 2nd helmet −second %. 2026-10-10 (Émile): the −second % is AUTOMATIC for everyone
  // (Shopify automatic discount « Flash sale »): no code, no popup, no countdown. The
  // code helpers below are kept inert so nothing else in this file changes.
  const OFFER = I18N.offer || { on: false, first: 0, second: 0, code: '' };
  // 2026-10-10: no code, no countdown → the 2nd-helmet line stops at « 2e casque −50 % ».
  I18N.lineSecond = String(I18N.lineSecond || '').split(' · ')[0];
  // Unpublished theme (preview link, theme editor): the discounts may not exist yet
  // in Shopify, so the "you save" line shows the expected amount, flagged as a preview.
  const IS_PREVIEW = !!(window.Shopify && window.Shopify.theme && window.Shopify.theme.role && window.Shopify.theme.role !== 'main');
  // The popup stores the code and its end of validity (1 hour). Expired = no code.
  function storedCode() {
    try {
      const code = localStorage.getItem('kdcp-code') || '';
      const exp = parseInt(localStorage.getItem('kdcp-code-exp') || '0', 10);
      if (code && exp && Date.now() > exp) return '';
      return code;
    } catch (e) { return ''; }
  }
  function minutesLeft() {
    try {
      const exp = parseInt(localStorage.getItem('kdcp-code-exp') || '0', 10);
      return exp ? Math.max(1, Math.ceil((exp - Date.now()) / 60000)) : 0;
    } catch (e) { return 0; }
  }
  function hasCode(cart) {
    // 2026-10-10: automatic discount, the 2nd helmet is always at −second %.
    if (OFFER.on) return true;
    if (storedCode()) return true;
    const want = String(OFFER.code || '').toUpperCase();
    const codes = (cart && cart.discount_codes) || [];
    return !!want && codes.some(function (c) { return c && String(c.code || '').toUpperCase() === want; });
  }
  function pctOff(cents, pct) { return Math.round((cents || 0) * (pct || 0) / 100); }
  function fill(tpl) {
    const code = storedCode();
    return String(tpl || '').replace(/{first}/g, OFFER.first).replace(/{second}/g, OFFER.second)
      .replace(/{code}/g, code && code !== '1' ? code : (OFFER.code || ''))
      .replace(/{m}/g, minutesLeft());
  }
  // Normal (not on sale) helmet price: the Shopify compare-at price once the sale is live, else the price.
  function helmetUnitPrice() {
    const p = CATALOG.protections[0];
    return p ? Math.max(p.compare_at_price || 0, p.price) : 0;
  }
  // Hat display price (29,99 $ planned at launch): the catalog carries max(Shopify price, theme setting).
  function hatDisplayPrice(variantId) {
    const v = CATALOG.hats.find(function (h) { return h.id === variantId; });
    return v ? (v.display_price || v.price) : 0;
  }

  // What each line shows (2026-10-07, Émile): the price after the offer with the normal price
  // struck. Helmet units are counted across the cart in line order: the 1st unit gets −first %,
  // the 2nd gets −second % when the email code is known (otherwise a note says how to get it),
  // the rest are full price. When Shopify has already applied a real discount to a line, the
  // larger of the two (real or expected) is shown, so the display never lags the checkout.
  function allocate(cart) {
    const code = hasCode(cart);
    let unitIndex = 0;
    const lines = cart.items.map(function (item) {
      const isHelmet = lineIsHelmet(item);
      const isHat = lineIsHat(item);
      // 2026-10-09: the helmet's normal price is its compare-at price once the sale is live (Shopify
      // charges the sale price on EVERY helmet; a Basic plan allows one product discount per line, so
      // "first helmet only" does not exist at checkout). The cart shows the same thing: every helmet
      // at −first %, the 2nd at −second % with the code.
      const cat = isHelmet ? catalogById(item.variant_id) : null;
      const unitOriginal = isHat ? Math.max(item.original_price, hatDisplayPrice(item.variant_id))
        : (cat && cat.compare_at_price > item.original_price ? cat.compare_at_price : item.original_price);
      const original = unitOriginal * item.quantity;
      let expected = 0, hasFirst = false, hasSecond = false, secondLocked = false;
      if (isHelmet && OFFER.on) {
        for (let q = 0; q < item.quantity; q += 1, unitIndex += 1) {
          if (unitIndex === 1 && OFFER.second) {
            if (code) { expected += pctOff(unitOriginal, OFFER.second); hasSecond = true; }
            else { expected += pctOff(unitOriginal, OFFER.first); secondLocked = true; }
          } else {
            expected += pctOff(unitOriginal, OFFER.first);
            if (unitIndex === 0) hasFirst = true;
          }
        }
      } else if (isHelmet) {
        unitIndex += item.quantity;
      }
      // 2026-10-14 (Émile) : le chapeau seul est 40 $ avec −first % automatique (« Limited time 25% chapeau »).
      if (isHat && OFFER.on) expected += pctOff(unitOriginal, OFFER.first) * item.quantity;
      const real = item.original_line_price - item.final_line_price;
      const discount = Math.max(real, expected);
      return { item: item, original: original, discount: discount, final: original - discount, real: real, expected: expected,
        hasFirst: hasFirst, hasSecond: hasSecond, secondLocked: secondLocked, isHelmet: isHelmet, isHat: isHat };
    });
    const realTotal = lines.reduce(function (t, l) { return t + l.real; }, 0);
    const expectedTotal = lines.reduce(function (t, l) { return t + l.expected; }, 0);
    // 2026-10-14 (Émile): the helmet is 69,99 $ and both rabais are automatic Shopify discounts
    // (« Limited time 25% » on 1 helmet, « 50% limited time » on 2). Shopify splits a 2-helmet
    // line into 69,99 $ + 17,49 $; when its total equals the offer's total, the drawer shows the
    // offer's split instead (1er casque −25 %, 2e casque −50 %). Otherwise only real money is shown.
    lines.forEach(function (l) {
      if (!IS_PREVIEW) l.discount = (realTotal === expectedTotal && expectedTotal > 0) ? l.expected : l.real;
      l.final = l.original - l.discount;
    });
    const subtotal = lines.reduce(function (t, l) { return t + l.final; }, 0);
    const saved = lines.reduce(function (t, l) { return t + l.discount; }, 0);
    return { lines: lines, code: code, subtotal: subtotal, saved: saved,
      preview: realTotal === 0 && expectedTotal > 0 && IS_PREVIEW };
  }

  const hatIds = new Set(CATALOG.hats.map(function (v) { return v.id; }));
  const protIds = new Set(CATALOG.protections.map(function (v) { return v.id; }));

  // 2026-10-07 (Émile): the cotton hat has its own product page again and can be
  // bought alone (spare cover). The 2026-09-08 rules that blocked a hat without a
  // helmet (locked last helmet, blocked checkout) are gone.
  let lastCart = null;
  let prevHelmets = -1; // helmets in the cart at the previous render (-1 = not rendered yet)
  const checkoutLink = drawer.querySelector('[data-kc-checkout]');
  const CHECKOUT_HREF = checkoutLink ? checkoutLink.getAttribute('href') : '/cart/checkout';
  function lineIsHelmet(item) { return protIds.has(item.variant_id); }
  function lineIsHat(item) { return hatIds.has(item.variant_id); }

  function catalogById(variantId) {
    var all = CATALOG.hats.concat(CATALOG.protections);
    for (var i = 0; i < all.length; i += 1) {
      if (all[i].id === variantId) return all[i];
    }
    return null;
  }

  function localizedPattern(t) { return (t && PATTERNS[t]) ? PATTERNS[t] : t; }
  function localizedProductName(item) {
    if (protIds.has(item.variant_id)) return I18N.nameProtection || item.product_title;
    if (hatIds.has(item.variant_id)) return I18N.nameHat || item.product_title;
    return item.product_title;
  }

  const LOCALE = document.documentElement.lang || 'en';
  const MONEY_FORMATTER = new Intl.NumberFormat(LOCALE.indexOf('fr') === 0 ? 'fr-CA' : 'en-CA', {
    style: 'currency',
    currency: 'CAD'
  });

  // 2026-10-08 (Émile): Canadian dollars written clearly, FR "52,49 $ CA", EN "CA$52.49" (same as snippets/kdc-money.liquid).
  function money(cents) {
    const n = MONEY_FORMATTER.format((cents || 0) / 100);
    return LOCALE.indexOf('fr') === 0 ? n + '\u00A0CA' : 'CA' + n;
  }

  // 2026-10-07 (Émile): the bar sits under the items, with the two steps only, no sentence.
  // 0 helmet = empty; 1 helmet = half (−first % earned); 2 helmets AND the email code = full.
  function updateProgress(sav) {
    if (!progressEl) return;
    if (!OFFER.on) { progressEl.style.display = 'none'; return; }
    const h = sav.st.protections;
    const code = sav.code;
    const pct = h === 0 ? 0 : (h >= 2 && code ? 100 : 50);
    const reached = pct === 100;
    progressEl.classList.toggle('is-unlocked', reached);
    if (progressBar) {
      progressBar.style.background = 'linear-gradient(to right, #f6d110 ' + pct + '%, #e6f2f4 ' + pct + '%)';
      progressBar.style.transition = 'background .6s ease';
      progressBar.classList.toggle('kc-cart__progress-bar--pulse', !reached && pct > 0);
    }
    progressEl.querySelectorAll('[data-kc-step]').forEach(function (el) {
      const step = el.getAttribute('data-kc-step');
      el.classList.toggle('is-done', step === '1' ? h >= 1 : (h >= 2 && code));
    });
  }

  function renderItems(cart) {
    if (!itemsEl) return;
    itemsEl.innerHTML = '';
    const tPattern = itemsEl.dataset.tPattern;
    const tSize = itemsEl.dataset.tSize;
    const tSizeVal = itemsEl.dataset.tSizeValue;
    const tMinus = itemsEl.dataset.tQtyMinus;
    const tPlus = itemsEl.dataset.tQtyPlus;
    const tRemove = itemsEl.dataset.tRemove;
    const tFullSet = itemsEl.dataset.tFullSet || '';
    const tHatNote = itemsEl.dataset.tHatNote || '';
    const alloc = allocate(cart);

    alloc.lines.forEach(function(l, idx) {
      const item = l.item;
      const compareLine = l.discount > 0 ? l.original : 0;
      const isHat = l.isHat;
      const isHelmet = l.isHelmet;
      // Offer notes under the line (2026-10-07): "1er casque −25 %", "2e casque −50 % avec votre
      // code", or the small warning telling how to get the −50 % on the 2nd one.
      let offerLines = '';
      if (l.hasFirst) offerLines += '<div class="kc-cart__line-offer">' + escapeHtml(fill(I18N.lineFirst)) + '</div>';
      if (l.isHat && l.discount > 0 && OFFER.on) offerLines += '<div class="kc-cart__line-offer">' + escapeHtml(String(I18N.offLabel || '').replace(/{pct}/g, OFFER.first)) + '</div>';
      if (l.hasSecond) offerLines += '<div class="kc-cart__line-offer">' + escapeHtml(fill(I18N.lineSecond)) + '</div>';
      if (l.secondLocked) offerLines += '<div class="kc-cart__line-warn">' + escapeHtml(fill(I18N.lineSecondWarn)) + ' <button type="button" class="kc-cart__offer-link" data-kc-get-code>' + escapeHtml(I18N.getCode || '') + '</button></div>';
      const patternLabel = (item.variant_title && item.variant_title !== 'Default Title') ? localizedPattern(item.variant_title) : '';
      // Helmet: "Full set: 1 helmet + 1 cotton cover <pattern>". Hat: pattern + "hat only" note.
      let detailLines = '';
      if (isHelmet) {
        detailLines += (patternLabel && tFullSet ? '<div class="kc-cart__line-variant">' + escapeHtml(tFullSet.replace('{pattern}', patternLabel)) + '</div>' : '');
        detailLines += '<div class="kc-cart__line-variant">' + tSize + ': ' + tSizeVal + '</div>';
      } else if (isHat) {
        detailLines += (patternLabel ? '<div class="kc-cart__line-variant">' + escapeHtml(patternLabel) + '</div>' : '');
        detailLines += (tHatNote ? '<div class="kc-cart__line-note">' + escapeHtml(tHatNote) + '</div>' : '');
      } else {
        detailLines += (patternLabel ? '<div class="kc-cart__line-variant">' + tPattern + ': ' + escapeHtml(patternLabel) + '</div>' : '');
      }
      const line = document.createElement('div');
      line.className = 'kc-cart__line';
      line.setAttribute('data-line-key', item.key);
      line.setAttribute('data-line-kind', isHelmet ? 'helmet' : (isHat ? 'hat' : 'other'));
      line.innerHTML = [
        '<img class="kc-cart__line-image" src="' + (item.image ? item.image.replace(/_(?:small|grande|medium|large)\./, '_144x.') : '') + '" alt="" loading="lazy">',
        '<div class="kc-cart__line-body">',
          '<h3 class="kc-cart__line-title">' + escapeHtml(localizedProductName(item)) + '</h3>',
          detailLines,
          offerLines,
          '<div class="kc-cart__line-qty">',
            '<button type="button" data-kc-qty-minus aria-label="' + tMinus + '">−</button>',
            '<span class="kc-cart__line-qty-val" data-kc-qty-val>' + item.quantity + '</span>',
            '<button type="button" data-kc-qty-plus aria-label="' + tPlus + '">+</button>',
          '</div>',
        '</div>',
        '<div class="kc-cart__line-side">',
          '<div class="kc-cart__line-prices">',
            '<span class="kc-cart__line-price">' + money(l.final) + '</span>',
            (compareLine ? '<span class="kc-cart__line-compare">' + money(compareLine) + '</span>' : ''),
          '</div>',
          '<button type="button" class="kc-cart__line-remove" data-kc-remove aria-label="' + tRemove + '" title="' + tRemove + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg></button>',
        '</div>'
      ].join('');
      itemsEl.appendChild(line);
    });
  }

  function classifyCart(cart) {
    let hats = 0, protections = 0, protSubtotal = 0;
    cart.items.forEach(function (item) {
      if (hatIds.has(item.variant_id)) {
        hats += item.quantity;
      } else if (protIds.has(item.variant_id)) {
        protections += item.quantity;
        protSubtotal += item.final_line_price;
      }
    });
    return { hats: hats, protections: protections, protSubtotal: protSubtotal, n: hats + protections };
  }

  // What the shopper saves, for the line at the bottom of the cart (2026-10-07, Émile).
  //  - real: the discounts Shopify actually applied to this cart (cart.total_discount)
  //  - expected: what the offer gives (1st helmet −first %, 2nd helmet −second % with
  //    the email code). Shown only on an unpublished theme while the discounts do not
  //    exist yet in Shopify, flagged "preview". On the live theme, only real money counts.
  function computeSavings(cart) {
    const a = allocate(cart);
    return {
      st: classifyCart(cart),
      code: a.code,
      units: cart.item_count || 0,
      subtotal: a.subtotal,
      saved: a.saved,
      preview: a.preview
    };
  }

  function showSaveMore(visible) {
    if (!saveMoreEl) return;
    saveMoreEl.style.display = visible ? '' : 'none';
    if (visible) saveMoreEl.hidden = false;
  }

  // Upsell (2026-10-07, Émile): a helmet first, then the cotton hat.
  //  - no helmet in the cart: the 4 helmets at the 1st-helmet price
  //  - 1 helmet: a 2nd helmet at −second % (with the email code), then a spare hat
  //  - 2 helmets or more: the spare hat only
  function upsellGroups(cart) {
    const st = classifyCart(cart);
    const code = hasCode(cart);
    const unit = helmetUnitPrice();
    const groups = [];
    if (st.protections === 0) {
      const first = OFFER.on ? OFFER.first : 0;
      groups.push({
        type: 'protection',
        title: I18N.upFirst,
        sub: first ? fill(I18N.upFirstSub) : '',
        items: CATALOG.protections,
        now: unit - pctOff(unit, first),
        was: first ? unit : 0,
        small: ''
      });
    } else if (st.protections === 1 && OFFER.on && OFFER.second) {
      groups.push({
        type: 'protection',
        title: fill(I18N.upSecond),
        sub: I18N.upSecondSub, // 2026-10-10: no code text any more
        items: CATALOG.protections,
        now: unit - pctOff(unit, OFFER.second),
        was: unit,
        small: code ? '' : (I18N.withCode || '')
      });
    }
    if (st.protections >= 1 && st.hats < 4) {
      groups.push({ type: 'hat', title: I18N.upHat, sub: I18N.upHatSub, items: CATALOG.hats });
    }
    return groups;
  }

  function renderSaveMore(cart) {
    if (!saveMoreEl || !saveMoreGrid) return;
    saveMoreGrid.innerHTML = '';
    if (!cart.items || cart.items.length === 0) { showSaveMore(false); return; }
    const groups = upsellGroups(cart).filter(function (g) { return g.items && g.items.length; });
    if (!groups.length) { showSaveMore(false); return; }
    showSaveMore(true);
    const G = saveMoreEl.dataset;

    groups.forEach(function (g) {
      const wrap = document.createElement('div');
      wrap.className = 'kc-cart__up-group';
      wrap.setAttribute('data-kc-up', g.type);
      const head = '<p class="kc-cart__up-title">' + escapeHtml(g.title) + '</p>' +
        (g.sub ? '<p class="kc-cart__up-sub">' + escapeHtml(g.sub) + '</p>' : '');
      const cards = g.items.slice(0, 4).map(function (v) {
        const pattern = localizedPattern(v.title);
        const label = (g.type === 'hat' ? (G.tTagHat || I18N.tagHat || '') : (I18N.tagProtection || '')) + ' · ' + pattern;
        let price;
        if (g.type === 'hat') {
          const hatWas = v.display_price || v.price;
          price = OFFER.on && OFFER.first ? '<b>' + escapeHtml(money(hatWas - pctOff(hatWas, OFFER.first))) + '</b> <s>' + escapeHtml(money(hatWas)) + '</s>'
            : '<b>' + escapeHtml(money(hatWas)) + '</b>';
        } else {
          price = '<b>' + escapeHtml(money(g.now)) + '</b>' +
            (g.was ? ' <s>' + escapeHtml(money(g.was)) + '</s>' : '') +
            (g.small ? '<small>' + escapeHtml(g.small) + '</small>' : '');
        }
        return [
          '<div class="kc-cart__save-more-card" data-kc-save-more-add data-variant-id="' + v.id + '" data-kc-label="' + escapeHtml(label) + '" role="button" tabindex="0" aria-label="' + escapeHtml(label) + '">',
            '<div class="kc-cart__save-more-card-media">',
              '<img class="kc-cart__save-more-card-image" src="' + escapeHtml(v.image || '') + '" alt="" loading="lazy">',
            '</div>',
            '<div class="kc-cart__save-more-card-name">' + escapeHtml(pattern) + '</div>',
            '<div class="kc-cart__up-price">' + price + '</div>',
          '</div>'
        ].join('');
      }).join('');
      wrap.innerHTML = head + '<div class="kc-cart__up-grid">' + cards + '</div>';
      saveMoreGrid.appendChild(wrap);
    });
  }

  function escapeHtml(str) {
    if (str == null) return '';
    return String(str).replace(/[&<>"']/g, function(c) {
      return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
    });
  }

  // Render straight from a cart object (no extra network call).
  function renderCart(cart) {
    if (!cart || cart.status) return; // cart.status set means an error payload
    lastCart = cart;
    const sav = computeSavings(cart);
    renderItems(cart);
    renderSaveMore(cart);
    // Subtotal after the offer (2026-10-07, Émile: the real price, 52,49 $ not 69,99 $).
    if (subtotalEl) subtotalEl.textContent = money(sav.subtotal);
    // "You save" line at the bottom of the cart.
    if (savedRow) {
      savedRow.hidden = !(sav.saved > 0);
      if (savedAmt) savedAmt.textContent = sav.saved > 0 ? money(sav.saved) : '';
    }
    // 2 helmets + the email code: send the code along to the checkout.
    if (checkoutLink) {
      const own = storedCode();
      const codeName = own && own !== '1' ? own : OFFER.code;
      // 2026-10-10: automatic discount, no code is ever sent to the checkout.
      const sendCode = false && OFFER.on && codeName && sav.code && sav.st.protections >= 2;
      checkoutLink.setAttribute('href', sendCode
        ? CHECKOUT_HREF + (CHECKOUT_HREF.indexOf('?') === -1 ? '?' : '&') + 'discount=' + encodeURIComponent(codeName)
        : CHECKOUT_HREF);
    }
    updateProgress(sav);
    drawer.classList.toggle('is-empty', cart.item_count === 0);
    // 2026-10-08 (Émile): the moment a 2nd helmet enters the cart, offer the code (once per visit).
    if (OFFER.on && sav.st.protections >= 2 && !sav.code && prevHelmets < 2 && prevHelmets >= 0) {
      let seen = false;
      try { seen = sessionStorage.getItem('kdcp-2nd') === '1'; } catch (e) {}
      if (!seen && window.KDCPopup && typeof window.KDCPopup.open === 'function') {
        try { sessionStorage.setItem('kdcp-2nd', '1'); } catch (e) {}
        setTimeout(function () { window.KDCPopup.open(); }, 600);
      }
    }
    prevHelmets = sav.st.protections;

    // Keep the header cart bubble in sync, so removing an item updates the count badge.
    var cartLink = document.getElementById('cart-icon-bubble');
    if (cartLink) {
      var countEl = cartLink.querySelector('.kdc-header__cart-count');
      if (cart.item_count > 0) {
        var t = cart.item_count < 100 ? String(cart.item_count) : '99+';
        if (!countEl) {
          countEl = document.createElement('span');
          countEl.className = 'kdc-header__cart-count';
          cartLink.appendChild(countEl);
        }
        countEl.textContent = t;
      } else if (countEl) {
        countEl.remove();
      }
    }
  }

  function refresh() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(renderCart)
      .catch(function() { /* swallow */ });
  }

  function addVariantToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: quantity || 1 }] }),
      credentials: 'same-origin'
    }).then(refresh);
  }

  function changeQty(key, qty) {
    // change.js already returns the full updated cart → render from it (no second fetch).
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
      credentials: 'same-origin'
    }).then(function(r) { return r.json(); }).then(renderCart).catch(function(){});
  }

  drawer.addEventListener('click', function(e) {
    const line = e.target.closest('.kc-cart__line');
    if (!line) return;
    const key = line.getAttribute('data-line-key');
    const qtyVal = line.querySelector('[data-kc-qty-val]');
    if (e.target.closest('[data-kc-qty-plus]')) {
      const next = parseInt(qtyVal.textContent, 10) + 1;
      if (qtyVal) qtyVal.textContent = next;        // optimistic → feels instant
      changeQty(key, next);
    } else if (e.target.closest('[data-kc-qty-minus]')) {
      const next = Math.max(0, parseInt(qtyVal.textContent, 10) - 1);
      if (qtyVal && next > 0) qtyVal.textContent = next; // optimistic (0 = removal, let re-render handle)
      changeQty(key, next);
    } else if (e.target.closest('[data-kc-remove]')) {
      changeQty(key, 0);
    }
  });

  // Upsell cards: the whole card adds the item (no + button)
  function addFromCard(card) {
    const id = card.getAttribute('data-variant-id');
    if (!id || card.classList.contains('is-adding')) return;
    card.classList.add('is-adding');
    addVariantToCart(id).finally(function() { card.classList.remove('is-adding'); });
  }
  if (saveMoreGrid) {
    saveMoreGrid.addEventListener('click', function(e) {
      const card = e.target.closest('[data-kc-save-more-add]');
      if (card) addFromCard(card);
    });
    saveMoreGrid.addEventListener('keydown', function(e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      const card = e.target.closest('[data-kc-save-more-add]');
      if (card) { e.preventDefault(); addFromCard(card); }
    });
  }

  // "Get my code" (note under the 2nd helmet line) opens the email popup, above the cart.
  drawer.addEventListener('click', function (e) {
    if (!e.target.closest('[data-kc-get-code]')) return;
    if (window.KDCPopup && typeof window.KDCPopup.open === 'function') window.KDCPopup.open();
  });
  // The popup announces a sign-up: redraw the bar, the cards and the savings.
  document.addEventListener('kdc:offer-code', function () {
    if (lastCart) renderCart(lastCart); else refresh();
  });
  // The code lasts one hour: keep the "x min left" and the expiry honest while the cart is open.
  setInterval(function () {
    if (lastCart && drawer.classList.contains('active')) renderCart(lastCart);
  }, 60000);

  // Populate everything from the live cart on load (items, savings, progress, upsell).
  refresh();

  // Listen for external cart updates (existing cart.js publishes via subscribe(), but we also poll on open)
  document.addEventListener('cart:updated', refresh);

  // Refresh whenever drawer is opened (in case cart changed elsewhere)
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.attributeName === 'class' && drawer.classList.contains('active')) {
          refresh();
        }
      });
    }).observe(drawer, { attributes: true });

  }
})();
